export default __webpack_public_path__ + "static/media/SFALogo.a2059ebb.svg";